import { DocumentTypeId, SocietyTypeId } from "@/constants/enums/Legal";

import type { SocietyDefinition } from "./types";

export const SOCIETIES: SocietyDefinition[] = [
  {
    id: SocietyTypeId.SA,
    name: "SOCIEDAD ANÓNIMA (S.A.)",
    documents: [
      {
        id: DocumentTypeId.ESTATUTO_SOCIAL,
        name: "Estatuto Social/Contrato Social con certificación notarial.",
        required: true,
      },
      {
        id: DocumentTypeId.INSCRIPCION_ESTATUTO,
        name:
          "Constancia de inscripción del Estatuto Social/Contrato Social ante el Registro Público correspondiente.",
        required: true,
      },
      {
        id: DocumentTypeId.ACTA_AUTORIDADES,
        name: "Acta de designación de autoridades vigentes.",
        required: true,
      },
      {
        id: DocumentTypeId.CERTIFICACION_AUTORIDADES,
        name:
          "Certificación notarial y/o inscripción registral del acta de designación de autoridades.",
        required: true,
      },
      {
        id: DocumentTypeId.MODIFICACIONES_ESTATUTO,
        name:
          "Modificaciones al Estatuto Social con constancia de inscripción registral.",
        required: false,
      },
      {
        id: DocumentTypeId.PODER_GENERAL,
        name: "Poderes generales amplios (Apoderados)",
        required: true,
      },
      {
        id: DocumentTypeId.OTRO,
        name: "Otro",
        required: false,
      },
    ],
  },
  {
    id: SocietyTypeId.SRL,
    name: "SOCIEDAD RESPONSABILIDAD LIMITADA (S.R.L.)",
    documents: [
      {
        id: DocumentTypeId.ESTATUTO_SOCIAL,
        name: "Estatuto Social/Contrato Social con certificación notarial.",
        required: true,
      },
      {
        id: DocumentTypeId.INSCRIPCION_ESTATUTO,
        name:
          "Constancia de inscripción del Estatuto Social/Contrato Social ante el Registro Público correspondiente.",
        required: true,
      },
      {
        id: DocumentTypeId.ACTA_AUTORIDADES,
        name: "Acta de designación de autoridades vigentes.",
        required: true,
      },
      {
        id: DocumentTypeId.CERTIFICACION_AUTORIDADES,
        name:
          "Certificación notarial y/o inscripción registral del acta de designación de autoridades.",
        required: true,
      },
      {
        id: DocumentTypeId.MODIFICACIONES_ESTATUTO,
        name:
          "Modificaciones al Estatuto Social con constancia de inscripción registral.",
        required: false,
      },
      {
        id: DocumentTypeId.PODER_GENERAL,
        name: "Poderes generales amplios (Apoderados)",
        required: true,
      },
      {
        id: DocumentTypeId.OTRO,
        name: "Otro",
        required: false,
      },
    ],
  },
  {
    id: SocietyTypeId.SAS,
    name: "SOCIEDAD POR ACCIONES SIMPLIFICADAS (S.A.S.)",
    documents: [
      {
        id: DocumentTypeId.ESTATUTO_SOCIAL,
        name: "Estatuto Social/Contrato Social con certificación notarial.",
        required: true,
      },
      {
        id: DocumentTypeId.INSCRIPCION_ESTATUTO,
        name:
          "Constancia de inscripción del Estatuto Social/Contrato Social ante el Registro Público correspondiente.",
        required: true,
      },
      {
        id: DocumentTypeId.ACTA_AUTORIDADES,
        name: "Acta de designación de autoridades vigentes.",
        required: true,
      },
      {
        id: DocumentTypeId.CERTIFICACION_AUTORIDADES,
        name:
          "Certificación notarial y/o inscripción registral del acta de designación de autoridades.",
        required: true,
      },
      {
        id: DocumentTypeId.MODIFICACIONES_ESTATUTO,
        name:
          "Modificaciones al Estatuto Social con constancia de inscripción registral.",
        required: false,
      },
      {
        id: DocumentTypeId.PODER_GENERAL,
        name: "Poderes generales amplios (Apoderados)",
        required: true,
      },
      {
        id: DocumentTypeId.OTRO,
        name: "Otro",
        required: false,
      },
    ],
  },
  {
    id: SocietyTypeId.SH,
    name: "SOCIEDAD DE HECHO (S.H.)",
    documents: [
      {
        id: DocumentTypeId.ESTATUTO_SOCIAL,
        name:
          "Contrato Social o Nota donde indiquen como es el Régimen de firmas de la sociedad certificada ante Escribano Público.",
        required: true,
      },
      {
        id: DocumentTypeId.CONSTANCIA_AFIP,
        name: "Constancia de AFIP.",
        required: true,
      },
      {
        id: DocumentTypeId.PODER_GENERAL,
        name: "Poderes generales amplios (Apoderados)",
        required: true,
      },
      {
        id: DocumentTypeId.OTRO,
        name: "Otro",
        required: false,
      },
    ],
  },
  {
    id: SocietyTypeId.CAPITULO_IV,
    name: "SOCIEDAD CAPÍTULO I SECCIÓN IV",
    documents: [
      {
        id: DocumentTypeId.CONTRATO_CAPITULO_IV,
        name: "Contrato Social con firmas certificadas ante Escribano Público.",
        required: true,
      },
      {
        id: DocumentTypeId.MODIFICACIONES_ESTATUTO,
        name: "Modificaciones posteriores con certificación notarial.",
        required: false,
      },
      {
        id: DocumentTypeId.PODER_GENERAL,
        name: "Poderes generales amplios (Apoderados)",
        required: true,
      },
      {
        id: DocumentTypeId.OTRO,
        name: "Otro",
        required: false,
      },
    ],
  },
  {
    id: SocietyTypeId.ASOCIACION_FUNDACION,
    name: "ASOCIACIONES Y FUNDACIONES",
    documents: [
      {
        id: DocumentTypeId.ESTATUTO_SOCIAL,
        name:
          "Instrumento Constitutivo/Estatuto Social/Contrato Social con certificación notarial.",
        required: true,
      },
      {
        id: DocumentTypeId.PERSONERIA_JURIDICA,
        name: "Constancia de otorgamiento de la personería jurídica.",
        required: true,
      },
      {
        id: DocumentTypeId.ACTA_AUTORIDADES,
        name: "Acta de designación de autoridades vigentes.",
        required: true,
      },
      {
        id: DocumentTypeId.CERTIFICACION_AUTORIDADES,
        name:
          "Certificación notarial y/o inscripción registral del acta de designación de autoridades.",
        required: true,
      },
      {
        id: DocumentTypeId.MODIFICACIONES_ESTATUTO,
        name: "Modificaciones al Instrumento Constitutivo/Estatuto Social.",
        required: false,
      },
      {
        id: DocumentTypeId.PODER_GENERAL,
        name: "Poderes generales amplios (Apoderados)",
        required: true,
      },
      {
        id: DocumentTypeId.OTRO,
        name: "Otro",
        required: false,
      },
    ],
  },
  {
    id: SocietyTypeId.COOPERATIVA,
    name: "COOPERATIVAS",
    documents: [
      {
        id: DocumentTypeId.ESTATUTO_SOCIAL,
        name:
          "Instrumento Constitutivo/Estatuto Social/Contrato Social con certificación notarial.",
        required: true,
      },
      {
        id: DocumentTypeId.CONSTANCIA_INAES,
        name:
          "Constancia de inscripción ante el INAES y la autorización para funcionar.",
        required: true,
      },
      {
        id: DocumentTypeId.ACTA_AUTORIDADES,
        name: "Acta de designación de autoridades vigentes.",
        required: true,
      },
      {
        id: DocumentTypeId.CERTIFICACION_AUTORIDADES,
        name:
          "Certificación notarial y/o inscripción registral del acta de designación de autoridades.",
        required: true,
      },
      {
        id: DocumentTypeId.MODIFICACIONES_ESTATUTO,
        name:
          "Modificaciones al Instrumento Constitutivo/Estatuto Social/Contrato Social con constancia de inscripción registral.",
        required: false,
      },
      {
        id: DocumentTypeId.PODER_GENERAL,
        name: "Poderes generales amplios (Apoderados)",
        required: true,
      },
      {
        id: DocumentTypeId.OTRO,
        name: "Otro",
        required: false,
      },
    ],
  },
  {
    id: SocietyTypeId.SCS,
    name: "SOCIEDADES EN COMANDITA SIMPLE (S.C.S.)",
    documents: [
      {
        id: DocumentTypeId.ESTATUTO_SOCIAL,
        name: "Estatuto Social/Contrato Social con certificación notarial.",
        required: true,
      },
      {
        id: DocumentTypeId.INSCRIPCION_ESTATUTO,
        name:
          "Constancia de inscripción registral del Estatuto Social/Contrato Social ante el Registro Público correspondiente.",
        required: true,
      },
      {
        id: DocumentTypeId.ACTA_AUTORIDADES,
        name: "Acta de designación de autoridades vigentes.",
        required: true,
      },
      {
        id: DocumentTypeId.CERTIFICACION_AUTORIDADES,
        name:
          "Certificación notarial y/o inscripción registral del acta de designación de autoridades.",
        required: true,
      },
      {
        id: DocumentTypeId.MODIFICACIONES_ESTATUTO,
        name:
          "Modificaciones al Estatuto Social con constancia de inscripción registral.",
        required: false,
      },
      {
        id: DocumentTypeId.PODER_GENERAL,
        name: "Poderes generales amplios (Apoderados)",
        required: true,
      },
      {
        id: DocumentTypeId.OTRO,
        name: "Otro",
        required: false,
      },
    ],
  },
  {
    id: SocietyTypeId.SCA,
    name: "SOCIEDADES EN COMANDITA POR ACCIONES (S.C.A.)",
    documents: [
      {
        id: DocumentTypeId.ESTATUTO_SOCIAL,
        name: "Estatuto Social/Contrato Social con certificación notarial.",
        required: true,
      },
      {
        id: DocumentTypeId.INSCRIPCION_ESTATUTO,
        name:
          "Constancia de inscripción registral del Estatuto Social/Contrato Social ante el Registro Público correspondiente.",
        required: true,
      },
      {
        id: DocumentTypeId.ACTA_AUTORIDADES,
        name: "Acta de designación de autoridades vigentes.",
        required: true,
      },
      {
        id: DocumentTypeId.CERTIFICACION_AUTORIDADES,
        name:
          "Certificación notarial y/o inscripción registral del acta de designación de autoridades.",
        required: true,
      },
      {
        id: DocumentTypeId.MODIFICACIONES_ESTATUTO,
        name:
          "Modificaciones al Estatuto Social con constancia de inscripción registral.",
        required: false,
      },
      {
        id: DocumentTypeId.PODER_GENERAL,
        name: "Poderes generales amplios (Apoderados)",
        required: true,
      },
      {
        id: DocumentTypeId.OTRO,
        name: "Otro",
        required: false,
      },
    ],
  },
];

export const DOCUMENT_TYPE_LABELS: Record<number, string> = SOCIETIES
  .flatMap((soc) => soc.documents)
  .reduce((acc, doc) => {
    acc[doc.id] = doc.name;
    return acc;
  }, {} as Record<number, string>);

export const DOCUMENT_REQUIRED_MAP: Record<number, boolean> = SOCIETIES
  .flatMap((soc) => soc.documents)
  .reduce((acc, doc) => {
    acc[doc.id] = doc.required;
    return acc;
  }, {} as Record<number, boolean>);
  

export function getSocietyDefinition(societyId: number) {
  return SOCIETIES.find((s) => s.id === societyId) ?? null;
}